export const homeConstant = {
  GET_STARTED_STEP: "GET_STARTED_STEP",
  CHOOSE_ASSESSMENTS_STEP: "CHOOSE_ASSESSMENTS_STEP",
  CUSTOMIZE_STEP: "CUSTOMIZE_STEP",
  CONFIGURE_LAUNCH_STEP: "CONFIGURE_LAUNCH_STEP",
  PREVIOUS_STEP: "PREVIOUS_STEP",
  ASSESSMENT_REPORT: "ASSESSMENT_REPORT",
  BACK_TO_HOME: "BACK_TO_HOME",
  ADD_ITEM: "ADD_ITEM",
  FINAL_STEP: "FINAL_STEP",

  // Name Bucket Creation
  ADD_CAMPAIGN_NAME_REQUEST: "ADD_CAMPAIGN_NAME_REQUEST",
  ADD_CAMPAIGN_NAME: "ADD_CAMPAIGN_NAME",
  ADD_CAMPAIGN_NAME_ERROR: "ADD_CAMPAIGN_NAME_ERROR",

  // Campaign Config Creation
  ADD_CAMPAIGN_CONFIG_REQUEST: "ADD_CAMPAIGN_CONFIG_REQUEST",
  ADD_CAMPAIGN_CONFIG: "ADD_CAMPAIGN_CONFIG",
  ADD_CAMPAIGN_CONFIG_ERROR: "ADD_CAMPAIGN_CONFIG_ERROR",

  // Create Competencies Creation

  ADD_COMPETENCIES_REQUEST: "ADD_COMPETENCY_REQUEST",
  ADD_COMPETENCIES: "ADD_COMPETENCIES",
  ADD_COMPETENCIES_ERROR: "ADD_COMPETENCIES_ERROR",

  // email
  SEND_SINGLE_INVITE_REQUEST: "SEND_SINGLE_INVITE_REQUEST",
  SEND_SINGLE_INVITE: "SEND_SINGLE_INVITE",
  SEND_SINGLE_INVITE_ERROR: "SEND_SINGLE_INVITE_ERROR",

  GET_BUCKET_NAME_SUCCESS: "GET_BUCKET_NAME_SUCCESS",

  GET_BUCKET_NAME_SUCCESS_ERROR: "GET_BUCKET_NAME_SUCCESS_ERROR",

  SEND_BULK_INVITE_REQUEST: "SEND_BULK_INVITE_REQUEST",
  SEND_BULK_INVITE: "SEND_BULK_INVITE",
  SEND_BULK_INVITE_ERROR: "SEND_BULK_INVITE_ERROR",

  SEND_SUPPORT_EMAIL_REQUEST: "SEND_SUPPORT_EMAIL_REQUEST",
  SEND_SUPPORT_EMAIL: "SEND_SUPPORT_EMAIL",
  SEND_SUPPORT_ERROR: "SEND_SUPPORT_ERROR",

  // Template
  GET_EMAIL_TEMPLATE_REQUEST: "GET_EMAIL_TEMPLATE_REQUEST",
  GET_SUCCESS_EMAIL_TEMPLATE: "GET_SUCCESS_EMAIL_TEMPLATE",
  GET_EMAIL_TEMPLATE_ERROR: "GET_EMAIL_TEMPLATE_ERROR",
};
